<template>
  <article>
    <div class="inner">
      <ul class="breadcrumb">
        <li :class="{ active: step === 1, completed: step > 1 }">
          <div class="step">1. <span>{{ $t('payment.breadcrumbs.info') }}</span></div>
        </li>
        <li :class="{ active: step === 2, completed: step > 2 }">
          <div class="step">2. <span>{{ $t('payment.breadcrumbs.payment') }}</span></div>
        </li>
        <li :class="{ active: step === 3, completed: step > 3 }">
          <div class="step">3. <span>{{ $t('payment.breadcrumbs.confirmation') }}</span></div>
        </li>
      </ul>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PaymentBreadcrumb',
  props: {
    step: {
      type: Number,
      default: 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PaymentBreadcrumb.vue